export default getText => key =>
  ({
    summary: getText('MIA Summary', 'Patient_Tabs_Header'),
    diagnosis: getText('Diagnosis', 'Patient_Tabs_Header'),
    encounters: getText('Encounters', 'Patient_Tabs_Header'),
  }[key])
